var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"onboarding_container"}},[_c('app-bar'),_vm._v(" "),_c('v-main',{staticClass:"wrapper"},[_c('v-container',{staticClass:"container",attrs:{"fluid":""}},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6085fde0","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/Default.vue
// module id = 1780
// module chunks = 0